export enum SocketNamespace {
    Users = 'users',
    Clients = 'clients',
    GroupSession = 'group-session',
}

export enum SocketManagerEvent {
    Close = 'close',
    Error = 'error',
    Reconnect = 'reconnect',
    ReconnectAttempt = 'reconnect_attempt',
    ReconnectError = 'reconnect_error',
    ReconnectFailed = 'reconnect_failed',
}

export enum SocketEvent {
    Message = 'message',
    Connect = 'connect',
    ConnectError = 'connect_error',
    Disconnect = 'disconnect',
    Authenticated = 'authenticated',
    Reauthenticate = 'reauthenticate',
    Unauthorized = 'unauthorized',
    AliveCheck = 'alive-check',
    OnlineSessionChanged = 'online-session:change',
    OnlineSessionDeleted = 'online-session:delete',

    AppointmentSoon = 'appointment:soon',
    AppointmentStarted = 'appointment:started',
    SessionParticipantInvited = 'session:participant-invited',

    ActiveSessionChanged = 'active-session:change',
    ActiveSessionDeleted = 'active-session:delete',
    ActiveSessionPartiallyChanged = 'active-session:partial-change',
    ActiveSessionActivityData = 'active-session:activity:data',

    ActiveSessionActivityRequestStreamStart = 'active-session:activity:request-stream-start',
    // End of a spoken turn (push-to-talk released): a clip-based STT provider transcribes only once told.
    ActiveSessionActivityRequestStreamStop = 'active-session:activity:request-stream-stop',
    ActiveSessionActivityRequestStreamState = 'active-session:activity:request-stream-state',
    ActiveSessionActivityStreamState = 'active-session:activity:stream-state',
    // The server closed the stream itself (toggle voice input went silent): drop the recording state instead of
    // restarting the stream, which is what a provider-side close does.
    ActiveSessionActivityStreamStopped = 'active-session:activity:stream-stopped',
    // Voice channel: the agent's spoken reply, and the barge-in that invalidates whatever is queued to play.
    ActiveSessionActivityVoiceReply = 'active-session:activity:voice-reply',
    // Client switched the microphone on (the gesture that unlocks audio) — asks the server to replay the last
    // bot phrase so the greeting is heard the moment voice starts.
    ActiveSessionActivityRequestVoiceReply = 'active-session:activity:request-voice-reply',
    // The chatbot is ending the session — the client stops taking input (mic off, chat disabled) for the goodbye.
    ActiveSessionActivityChatbotEnding = 'active-session:activity:chatbot-ending',
    // Client tells the server its goodbye audio finished playing, so the session can end right after.
    ActiveSessionActivityVoiceReplyEnded = 'active-session:activity:voice-reply-ended',
    ActiveSessionActivityStreamChunkHandled = 'active-session:activity:stream-chunk-handled',
    ActiveSessionActivityStreamChunk = 'active-session:activity:stream-chunk',
    ActiveSessionActivityStreamInvalidParams = 'active-session:activity:invalid-params',

    ActiveSessionJoin = 'active-session:join',
    ActiveSessionJoinSuccess = 'active-session:join:success',
    ActiveSessionJoinError = 'active-session:join:error',

    Logout = 'user:logout',

    SessionChanged = 'session:change',
    SessionDeleted = 'session:delete',
    SessionSubscribe = 'session:subscribe',
    SessionSubscribeSuccess = 'session:subscribe:success',
    SessionSubscribeError = 'session:subscribe:error',

    ScreenRecorderStateChanged = 'screen-recorder-state:change',
    ScreenRecorderStateRequest = 'screen-recorder-state:request',

    ComplianceHint = 'compliance:hint',

    ProfileChanged = 'profile:change',
    ProfileAssignmentChanged = 'profile:assignment-change',
    ProfileDeleted = 'profile:delete',

    AccountPlanLimitsChanged = 'account-plan-limits:change',

    TaskCompleted = 'task:complete',
    TaskFailed = 'task:fail',
    TaskProgress = 'task:progress',
    CancelTask = 'task:cancel',

    NewConnection = 'connection:new',

    // Conversations events
    ConversationChanged = 'conversation:change',
    ConversationDeleted = 'conversation:delete',
    ConversationNewMessage = 'conversation:new-message',
    ConversationSubscribe = 'conversation:subscribe',
    ConversationUnsubscribe = 'conversation:unsubscribe',
}

// https://socket.io/docs/v4/client-api/#event-disconnect
export enum SocketDisconnectReason {
    ServerDisconnect = 'io server disconnect',
    ClientDisconnect = 'io client disconnect',
}

export enum PartialSessionChangeName {
    TextChat = 'text-chat',
    AudioVideo = 'audio-video',
    Audio = 'audio',
    Avatar = 'avatar',
    AgentChatbot = 'agent-chatbot'
}
